import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { Icon, Input, Button, Dropdown, Grid, Card, Popup, Segment, Tab, Table, Menu, Form, TextArea, Label, Header, Checkbox } from 'semantic-ui-react';
import { getkpidata, getkpidata1, getAgingDashboard, getkpidata3, getexceptiondata, getkpidata4, getexceptiondata1, getProcessingLayerListFromServer, getdashboard1sidement } from '../../../services/process/BRS/brsService';
import axios from "axios";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'semantic-ui-css/semantic.min.css';
import Modal from 'react-bootstrap/Modal';
import * as XLSX from 'xlsx';
import RenderCard from "./card";
import Select from "react-select";

import './dashboard_new.css';

import Accordion from 'react-bootstrap/Accordion';

import DualBarGraph from './dual_bar_graph';

import icici from '../../../assets/images/icici.png';
import SearchInput from './search_input';
import { faAlignCenter } from '@fortawesome/free-solid-svg-icons';


const DashboardComponent = () => {
  const [input1, setInput1] = useState('');
  const [input2, setInput2] = useState('');
  const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
  const [seriesdonut, setseriesdonut] = useState();
  const [serieslabels, setserieslabels] = useState([]);
  const [seriesdata, setseriesdata] = useState([]);
  const [extGridData, setExtGridData] = useState([]);
  const [modelcolumnnames, setmodelcolumnnames] = useState([]);

  const [serieslabels1, setserieslabels1] = useState([]);
  const [seriesdata1, setseriesdata1] = useState([]);

  const [kpidata2, setkpidata2] = useState([]);

  const [show, setShow] = useState(false);

  const [options, setOptions] = useState([]);
  const [options1, setOptions1] = useState([]);
  const [filterText, setFilterText] = useState('');

  const [clientids, setclientids] = useState([]);

  const [selectedcustomer, setselectedcustomer] = useState('');


  const [userid, setuserid] = useState(userCredentials["user_id"]);

  const [doughnutLabel, setDoughnutLabel] = useState(['Closed', 'Open', 'All', 'w/o bank advice', 'w/o customer advice', 'pending gst', 'Funding']);
  const [doughnutdata, setDoughnutData] = useState([20, 20, 120, 20, 20, 20, 20]);

  const [barwidth, setbarwidth] = useState('40%');
  const [radialseries, setradialseries] = useState([89.52]);
  let sideinfo_list = [];

  const chartDatanew = {
    series: doughnutdata,
    options: {
      labels: doughnutLabel,
      colors: ['#264be0', '#5a63c4', '#0A2352', '#b84dff', '#ff944d', '#00cccc', '#3E4C5E', '#4381C1', '#80A1C1', '#C7D3DD'],
      legend: {
        onItemClick: {
          toggleDataSeries: false,
        },

      },
      chart: {
        width: 280,
        height: 370,
        type: 'donut'
      },
      plotOptions: {
        pie: {
          startAngle: -90,
          endAngle: 270
        },
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        type: 'gradient',
      },
      // legend: doughnutLabel,
      title: {
        text: ''
      },

      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
            height: 250,
          },
          legend: {
            position: 'bottom'
          }
        }
      }],

    },
  };


  const intColumnDefs3 = React.useMemo(() => {
    if (extGridData && extGridData?.length > 0) {
      // Get the column names from the first row of the JSON data
      const keys = Object.keys(extGridData[0]);

      // Create column definitions with the checkbox as the first column
      const intColumnDefs = [

        ...keys.map((key) => ({
          headerName: key,
          field: key,
          sortable: true,
          filter: true,
          resizable: true
        })),
      ];
      setmodelcolumnnames(intColumnDefs);
      // console.log('intColumnDefs', intColumnDefs);
      return intColumnDefs;
    }
    return [];
  }, [extGridData]);


  function getKpiinfo3() {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["selectedentity"],
      'user_id': userCredentials["user_id"],

    }

    var getProcessingLayerDataWithStatus = getkpidata3();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          let data1 = data['outstanding_value'];
          setExtGridData(data1);
          setShow(true);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  function getKpiinfo4() {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["selectedentity"],
      'user_id': userCredentials["user_id"],

    }

    var getProcessingLayerDataWithStatus = getkpidata4();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          let data1 = data['outstanding_value'];
          setExtGridData(data1);
          setShow(true);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  const handleBarClick = (event, chartContext, config) => {
    console.log('clicked');
    getKpiinfo3();
  };

  const handleBarClick1 = (event, chartContext, config) => {
    console.log('clicked');
    getKpiinfo4();
  };

  const chartData1 = {
    series: [
      {
        name: 'Series 1',
        data: seriesdata,
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 450,
        toolbar: {
          show: false // Hide the toolbar
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: 'rounded',
          columnWidth: '30%'
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: serieslabels,
      },
      
      fill: {
        colors: ['#0a2352'],
      },
    },
  };

  const chartData2 = {
    series: [
      {
        name: 'Series 1',
        data: seriesdata1,
      },
    ],
    options: {
      chart: {
        type: 'bar',
        height: 250,
        toolbar: {
          show: false // Hide the toolbar
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: 'rounded',
          columnWidth: barwidth
        },
      },
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: serieslabels1,
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            // Format the y-axis labels as lakhs
            return (value / 100000).toLocaleString('en-IN') + ' Lakhs';
          },
        },
      },
      fill: {
        colors: ['#0a2352'],
      },
    },
  };

  const [totalsales, settotalsales] = useState('')
  const [overdueamount, setoverdueamount] = useState('')

  function getKpiinfo() {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["selectedentity"],
      'user_id': userCredentials["user_id"],

    }

    var getProcessingLayerDataWithStatus = getkpidata();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing donut Data With Status!!!", response)
          let data = response["data"];
          let percentage = data['percentage'];
          let total_sales = data['total_sales'];
          let overdue_amount = data['overdue_amount'];
          overdue_amount = (overdue_amount / 100000).toFixed(2) + ' L';
          total_sales = (total_sales / 100000).toFixed(2) + ' L';
          settotalsales(total_sales);
          setoverdueamount(overdue_amount);
          console.log('percentage', percentage);
          setradialseries([percentage])
          let arrays = data["data"];
          let array0 = arrays[0]
          let amount = array0[0].difference;
          const amountInLakhs = (amount / 100000).toFixed(2) + ' L';
          setInput1(amountInLakhs);
          let array1 = arrays[1]
          let amount1 = array1[0].TotalAmount;
          const amountInLakhs1 = (amount1 / 100000).toFixed(2) + ' L';

          setInput2(amountInLakhs1);
          let array2 = arrays[2]
          let overdue = array2[0].percentage;
          let not_overdue = 100 - overdue;
          const formattedNumber = overdue.toFixed(2);
          setseriesdonut(formattedNumber);

          let array3 = arrays[3]
          const filteredData = array3.slice(0, 7);
          console.log('filteredData', filteredData);
          const dueDates = filteredData.map(item => item.due_dt);
          const invoiceAmounts = filteredData.map(item => item.total_invoice_amount);
          
          setserieslabels(dueDates);
          setseriesdata(invoiceAmounts);

          // let table_data = data["data1"];
          // setExtGridData(table_data);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }


  function getagingdashboard() {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["selectedentity"],
      'user_id': userCredentials["user_id"],

    }

    var getProcessingLayerDataWithStatus = getAgingDashboard();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("aging dashboard data!!!", response)
          let data = response["data"];
          let filteredData = data['outstanding_value'];
          const labels = filteredData.map(item => item.AgeBucket);
          const series = filteredData.map(item => item.TotalInvoiceAmount);
          setserieslabels1(labels);
          setseriesdata1(series);

          let arrayLength = [];
          let datesArray = labels;
          arrayLength = datesArray && datesArray?.length;

          if (arrayLength == 3) {
            setbarwidth('40%')
          } else if (arrayLength == 2) {
            setbarwidth('30%')
          } else if (arrayLength == 1) {
            setbarwidth('10%')
          }
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  const [item, setitem] = useState({});
  const [item1, setitem1] = useState({});
  const [item2, setitem2] = useState({});
  const [item3, setitem3] = useState({});
  const [item4, setitem4] = useState('');
  const [item5, setitem5] = useState('');
  const [item6, setitem6] = useState('');
  const [item7, setitem7] = useState('');
  const [urls, seturls] = useState([]);

  const [show19, setshow19] = useState(true);

  const [secoundlabel, setsecoundlabel] = useState(['dispute', 'Funding']);
  const [secounddata, setsecounddata] = useState([104356, 678654]);

  function getKpiinfo1() {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["selectedentity"],
      'user_id': userCredentials["user_id"],

    }

    var getProcessingLayerDataWithStatus = getkpidata1();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          let data1 = data['outstanding_value'];
          let data2 = data['outstanding_value1'];
          let data3 = data['outstanding_value2'];
          let data4 = data['outstanding_value3'];
          let data5 = data['outstanding_value4'];

          const amountsInLakhs = data1.map(item => {
            const originalAmount = parseFloat(item.TotalInvoiceAmount);
            console.log('originalAmount', originalAmount);
            const amountInLakhs = originalAmount * 1; // 1 Lakh = 100,000
            return { ...item, TotalInvoiceAmount: amountInLakhs };
          });

          const delayedFunction = () => {
            setshow19(false);
          };

          const exceptions1 = amountsInLakhs.map(item => item.Exception);
          const amount1 = amountsInLakhs.map(item => item.TotalInvoiceAmount);

          const exceptions = [];
          const amount = [];

          amountsInLakhs.forEach(item => {
            exceptions.push(item.Exception);
            amount.push(item.TotalInvoiceAmount);
          });
          setsecoundlabel(exceptions);
          setsecounddata(amount);
          setDoughnutLabel(exceptions);
          setDoughnutData(amount)

          // setTimeout(delayedFunction, 2000);

          for (let item of data1) {
            if (item.Exception) {
              // Convert TotalInvoiceAmount to lakhs
              item.TotalInvoiceAmount = (item.TotalInvoiceAmount / 100000).toFixed(2) + ' L';
            }
          }

          for (let data in data1) {
            console.log('data', data1[data]);
            if (data1[data]['Exception'] == "Dispute") {
              let item_1 = data1[data];
              setitem(item_1)

            }

            if (data1[data]['Exception'] == "Credit Note") {
              let item_2 = data1[data];
              setitem1(item_2)
            }

            if (data1[data]['Exception'] == "Debit Note") {
              let item_3 = data1[data];
              setitem2(item_3)
            }

            if (data1[data]['Exception'] == "Duplicate Invoice") {
              let item_4 = data1[data];
              setitem3(item_4)
            }
          }

          let pending = data2[0]['total_invoice_amount']
          let approved = data3[0]['total_invoice_amount']
          pending = (pending / 100000).toFixed(2) + ' L';
          approved = (approved / 100000).toFixed(2) + ' L';
          setitem4(pending);
          setitem5(approved);
          let unallocated_credits = data4[0]['deposit_amount']
          let allocated_credits = data5[0]['deposit_amount']
          unallocated_credits = (unallocated_credits / 100000).toFixed(2) + ' L';
          allocated_credits = (allocated_credits / 100000).toFixed(2) + ' L';
          setitem6(unallocated_credits);
          setitem7(allocated_credits);

        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }


  const [uniqueValues, setUniqueValues] = useState([]);

  function handleSelection123(event, client_ids) {

    const filterKey = event;
    let client_ids1;
    // console.log('clientids', clientids);
    // Filter the data based on the specified key
    const filteredData = client_ids.filter(item => item.key === filterKey);
    // Create a Set to track unique values
    const uniqueSet = new Set();

    // Filter the data to remove duplicates
    const filteredData1 = filteredData.filter(item => {
      const value = item.value;

      // If the value is not in the Set, add it to the Set and keep the item
      if (!uniqueSet.has(value)) {
        uniqueSet.add(value);
        return true;
      }
      return false; // Skip duplicates
    });



    const uniqueValueSet = new Set(filteredData1.map(item => item.value));
    const uniqueValueArray = Array.from(uniqueValueSet);
    setUniqueValues(uniqueValueArray);
    console.log('uniqueValueArray', uniqueValueArray);
    sidemenulist(uniqueValueArray, event);

  }


  function BrsTypeList() {

    let payload = {
      "tenants": userCredentials["tenants_id"],
      "groups": userCredentials["groups_id"],
      "entities": userCredentials["selectedentity"],
      "mProcessingLayerId": 1,
      "mProcessingSubLayerId": 1,
      "typeId": 1,
      'user_id': userCredentials['user_id']
    }
    console.log('userCredentials["groups_id"],', userCredentials);
    var getProcessingLayerList = getProcessingLayerListFromServer();
    console.log("brs", getProcessingLayerList[0])

    axios.post(getProcessingLayerList[1], payload, getProcessingLayerList[0])
      .then(
        response => {
          console.log("Processing Layer List customer names!!!", response)
          let data1 = response["data"];
          console.log('data', data1);
          let data = data1['data_out']
          let urls = data1['urls']
          console.log('urls', urls);
          seturls(urls);
          if (data) {
            let options = data[0]["customer_names"];
            let client_ids = data[0]["client_ids"];
            console.log('options', options );
            const dataWithimg = options.map((item, index) => {
              console.log("matchingurl",options.label)
	      const matchingUrl = urls.find((url) => url.customer_name === item.label);
              return {
                ...item,
                image: matchingUrl ? matchingUrl.url : 'pidilite.png'// Assign image filename to "image" property
              };
            });

            sideinfo_list = dataWithimg;
            setOptions(dataWithimg);
            setOptions1(dataWithimg);
            setclientids(client_ids);

            setoutstandval([]);
            setoverdueval1([]);
            settotalval([]);
            setexceptionval([]);
            setdisputeval([]);

            console.log(options);
            options.map((data) => {
              console.log('data123', data);
              setTimeout(() => {
                handleSelection123(data.label, client_ids);
              }, 2000);

            })
          }

        }
      ).catch(
        error => {
          console.log("Error in Processing Layer List!!!", error);

        }
      );

  }

  const [outstandval, setoutstandval] = useState([]);
  const [overdueval1, setoverdueval1] = useState([]);
  const [totalval, settotalval] = useState([]);
  const [exceptionval, setexceptionval] = useState([]);
  const [disputeval, setdisputeval] = useState([]);

  const extractKeys = (data, event) => {
    // console.log(options_data);
    let data1 = data['outstand']
    let data2 = data['overdue']
    let data3 = data['total']

    
    const differenceValue = data1[0]?.difference;
    const overdueValue = data2[0]?.TotalAmount;
    const totalValue = data3[0]?.TotalAmount;

    let differenceValue1 = (differenceValue / 100000).toFixed(2) + ' L';
    let overdueValue1 = (overdueValue / 100000).toFixed(2) + ' L';
    let totalValue1 = (totalValue / 100000).toFixed(2) + ' L';

    let data4 = data['exception']
    console.log('data4 exception', data4);
    let exceptionList = [];
    data4?.forEach(item => {
      if(item.LastRecordException!=null){
        exceptionList.push(item.LastRecordException);
      }
    });

    console.log('exceptionList', exceptionList);
    // Remove duplicates using Set and convert it back to an array
    exceptionList = Array.from(new Set(exceptionList));

    const modifiedData = sideinfo_list?.map(item => {
      // console.log('item', item);
      if (item.label == event) {
        return {
          ...item,
          outstand: differenceValue1,
          overdue: overdueValue1,
          total: totalValue1,
          exception: exceptionList
        };
      }
      return item;
    });

    console.log('modifiedData1111', modifiedData);
    sideinfo_list = modifiedData;
    setOptions(modifiedData);
    setOptions1(modifiedData);
    

    let data5 = data['dispute']
    const disputeValue = data5[0]?.TotalAmount;
    // console.log(data4, data5);
    // setoutstandval((prevState) => [
    //   ...prevState,
    //   differenceValue1
    // ]);

    // setoverdueval1((prevState) => [
    //   ...prevState,
    //   overdueValue1
    // ]);

    // settotalval((prevState) => [
    //   ...prevState,
    //   totalValue1
    // ]);

    setexceptionval((prevState) => [
      ...prevState,
      [exceptionList]
    ]);

    // setdisputeval((prevState) => [
    //   ...prevState,
    //   disputeValue
    // ]);

  };

  function sidemenulist(value, event) {

    let payload = {
      "tenants": userCredentials["tenants_id"],
      "groups": userCredentials["groups_id"],
      "entities": userCredentials["selectedentity"],
      "mProcessingLayerId": 1,
      "mProcessingSubLayerId": 1,
      "typeId": 1,
      'user_id': userCredentials['user_id'],
      'client_ids': value,
      'client_name': event
    }
    // console.log('userCredentials["groups_id"],', userCredentials);
    var getProcessingLayerList = getdashboard1sidement();
    // console.log("brs", getProcessingLayerList[0])

    axios.post(getProcessingLayerList[1], payload, getProcessingLayerList[0])
      .then(
        response => {
          console.log("Processing Layer List sidemenu dropdown list!!!", response)
          let data = response["data"];
          // console.log('data', data);
          extractKeys(data, event);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer List!!!", error);

        }
      );

  }

  useEffect(() => {

    BrsTypeList();
    getKpiinfo();
    getKpiinfo1();
    getagingdashboard();

  }, []
  );



  const handleIconClick5 = () => {
    // Redirect to the desired URL
    window.location.href = '/arrecons'; // Replace with your URL
  };

  const handleClose = () => {

    setShow(false);
  }



  function getExceptiontypedata(exception) {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["selectedentity"],
      'user_id': userCredentials["user_id"],
      'exception': exception,

    }

    var getProcessingLayerDataWithStatus = getexceptiondata();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          let data1 = data['outstanding_value'];
          setExtGridData(data1);
          setShow(true);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }


  function getExceptiontypedata1(exception) {
    let payload = {
      'tenants_id': userCredentials["tenants_id"],
      'groups_id': userCredentials["groups_id"],
      'entities_id': userCredentials["selectedentity"],
      'user_id': userCredentials["user_id"],
      'exception': exception,

    }

    var getProcessingLayerDataWithStatus = getexceptiondata1();

    return axios.post(getProcessingLayerDataWithStatus[1], payload, getProcessingLayerDataWithStatus[0])
      .then(
        response => {
          console.log("Processing Layer Data With Status kpi info 1!!!", response)
          let data = response["data"];
          let data1 = data['outstanding_value'];
          setExtGridData(data1);
          setShow(true);
        }
      ).catch(
        error => {
          console.log("Error in Processing Layer Data WIth Status!!!", error);
        }
      );
  }

  const getFirstcarddata = () => {
    getExceptiontypedata(item1.Exception)
  }

  const getFirstcarddata1 = () => {
    getExceptiontypedata(item2.Exception)
  }

  const getFirstcarddata2 = () => {
    getExceptiontypedata(item.Exception)
  }

  const getFirstcarddata3 = () => {
    getExceptiontypedata(item3.Exception)
  }

  const getFirstcarddata4 = () => {
    getExceptiontypedata1('Outstanding value')
  }

  const getFirstcarddata5 = () => {
    getExceptiontypedata1('Over due')
  }

  const getFirstcarddata6 = () => {
    getExceptiontypedata1('% of overdue')
  }

  const getFirstcarddata10 = () => {
    getExceptiontypedata1('Pending')
  }

  const getFirstcarddata11 = () => {
    getExceptiontypedata1('Approved')
  }

  const getFirstcarddata12 = () => {
    console.log('called')
    getExceptiontypedata1('Unallocated Credits')
  }

  const getFirstcarddata13 = () => {
    getExceptiontypedata1('Allocated Credits')
  }

  function exportJsonToXLSX(data, sheetName, excelFileName) {
    try {
      var workBook = XLSX.utils.book_new();
      var workSheet = XLSX.utils.json_to_sheet(data, {
        skipHeader: false,
      });
      XLSX.utils.book_append_sheet(workBook, workSheet, sheetName);
      XLSX.writeFile(workBook, excelFileName);
      return true;
    }
    catch
    {
      return false;
    }
  }

  function exportToExcel() {
    let fileNameChange = "Report.xlsx";
    let sheetName = "sheet";

    let excelExportData = [];

    for (let i = 0; i < extGridData?.length; i++) {
      let data = {};
      for (let key in extGridData[i]) {
        for (let j = 0; j < modelcolumnnames?.length; j++) {
          if (key === modelcolumnnames[j]["field"]) {
            data[modelcolumnnames[j]["headerName"]] = extGridData[i][key]
          }
        }
      }

      excelExportData.push(data);
    };

    exportJsonToXLSX(excelExportData, sheetName, fileNameChange);

  }



  const cleckedcustomername = (value) => {
    // sidemenulist(value);
    // handleSelection123(value, clientids);
    console.log('clicked');
  }

  const chartState = {
    series: radialseries,
    options: {
      chart: {
        height: 200,
        type: 'radialBar',
        margin: 0,
      },
      plotOptions: {
        radialBar: {
          hollow: {
            margin: 0,
            size: '40%',
            background: '#0a2352',
          },
          dataLabels: {
            value: {
              color: '#fff',
              fontSize: '17px',
              show: true,
              offsetY: 0,
              align: 'center',
            },
            style: {
              fontSize: '160px',
              color: '#fff',
            },
          },
          fill: {
            type: 'solid',
            colors: ['#fffd01'],
          },
          stroke: {
            lineCap: 'round',
          },
        },
      },
      labels: [''],
      colors: ['#fffd01'],
    },
  };


  const [chartState1] = useState({
    series: secounddata,
    options: {
      chart: {
        type: 'donut',
      },
      labels: secoundlabel,
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    },
  });

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleMouseEnter = (index) => {
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  const truncateText = (text, maxChars) => {
    return text?.length > maxChars ? text?.slice(0, maxChars) + '...' : text;
  };

  const [imagePath, setImagePath] = useState('../../../assets/images/icici.png');


  const handleInput = (value) => {
    // Do something with the input value received from SearchInput component
    console.log('Input value:', value);
    let filteredData = options.filter(item =>
      item.label.toLowerCase().includes(value.toLowerCase())
    );
    setOptions1(filteredData);
  };

  return (
    <div id="dashboard1main" style={{ marginTop: '-1em'}}>

      <Grid className="mt-2 mb-2" style={{ marginLeft: '1em' }}>
        <Grid.Row >
          <Grid.Column style={{ width: '23%', backgroundColor: '#6d7991', height: '100%', overflowY: 'scroll' }} >
            <div className='pt-2' style={{ width: '107%', marginLeft: '-9px' }}>
              {/* <Input type='search' placeholder='Search..' id='dashbordinput1' /> */}
              < SearchInput onInputChange={handleInput} />
              <Accordion style={{ backgroundColor: 'white' }}>
                {options1.map((item, index) => (
                  <Accordion.Item
                    key={index}
                    eventKey={index.toString()}
                    onMouseEnter={() => handleMouseEnter(index)}
                    onMouseLeave={handleMouseLeave}
                    style={{ position: 'relative' }}
                  >
                    <Accordion.Header style={{ display: 'flex', alignItems: 'center' }} onClick={e => cleckedcustomername(item.label)}>
                      {urls[index] && urls[index].url ? (
                        <img
                          src={require('../../../assets/images/bank_img/' + item.image)}
                          alt="Your Image"
                          style={{
                            marginRight: '10px',
                            borderRadius: '50%', // Make the image round
                            width: '50px', // Adjust the image size as needed
                            height: '50px',
                            border: '1px solid gray',
                          }}
                        />
                      ) : (
                        <img
                          src=''
                          alt="Your Image"
                          style={{
                            marginRight: '10px',
                            borderRadius: '50%', // Make the image round
                            width: '50px', // Adjust the image size as needed
                            height: '50px',
                            border: '1px solid gray',
                          }}
                        />
                      )}


                      <span style={{ flex: 1 }} >{truncateText(item.label, 15)}</span>
                      {hoveredIndex === index && (
                        <div
                          style={{
                            position: 'absolute',
                            top: '-25px', // Adjust position as needed
                            left: '30%',
                            backgroundColor: 'rgba(0, 0, 0, 0.7)',
                            color: 'white',
                            padding: '5px',
                            borderRadius: '5px',

                          }}
                        >
                          <p>{item.label}</p>

                        </div>)}
                      {/* <p><strong>{outstandval[index]}</strong> </p> */}
                    </Accordion.Header>
                    <Accordion.Body className='p-1'>
          
                      <div style={{ width: '100%' }}>
                        <div className="contentGroup">
                          <div className="contentPair">
                            <p style={{ textAlign: 'right', margin: '0', width: '44%' }}><strong>Total val : </strong></p>
                            <p style={{ textAlign: 'left', margin: '0', paddingLeft: '10px', width: '54%' }} className='pl-1'> {item.total}</p>
                          </div>
                          <div className="contentPair">
                            <p style={{ textAlign: 'right', margin: '0', width: '44%' }}><strong>Outstanding : </strong></p>
                            <p style={{ textAlign: 'left', margin: '0', paddingLeft: '10px' }}> {item.outstand}</p>
                          </div>

                          <div className="contentPair">
                            <p style={{ textAlign: 'right', margin: '0', width: '44%' }}><strong>Overdue : </strong></p>
                            <p style={{ textAlign: 'left', margin: '0', paddingLeft: '10px' }} className='pl-1'> {item.overdue}</p>
                          </div>

                          <div className="contentPair">
                            <p style={{ textAlign: 'right', margin: '0', width: '44%' }}><strong>Exception : </strong></p>
                            <p style={{ textAlign: 'left', margin: '0', paddingLeft: '10px', width: '54%', wordBreak: 'break-all' }} className='pl-1'> {item.exception}</p>
                          </div>

                          {/* <div className="contentPair">
          <p style={{ textAlign: 'right', margin: '0', width: '44%' }}><strong>Dispute : </strong></p>
          <p style={{ textAlign: 'left', margin: '0', paddingLeft:'10px' }} className='pl-1'> {disputeval[index]}</p>
        </div> */}
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>

          </Grid.Column>

          <Grid.Column style={{ width: '77%' }}>   
            <Grid.Row style={{ paddingLeft: '5.2px' }}>
              <Grid.Column style={{ width: '40%' }} onClick={getFirstcarddata4}>

                <div className='row' style={{ border: '1px solid gray', borderRadius: '10px', backgroundColor: 'white' }}>
                  <div id="chart" className='col-md-4' >
                    <ReactApexChart options={chartState.options} series={chartState.series} type="radialBar" height={140} />
                  </div>
                  <div className='col-md-8 mt-2'>
                    <div>
                      <span className='row pb-3'>
                        <span className='col-md-7 text-end p-0'>Total sales : </span>
                        <span className="fw-bold col-md-5 text-start">{totalsales}</span>
                      </span>
                      <span className='row pb-3'>
                        <span className='col-md-7 text-end p-0'>Outstanding : </span>
                        <span className="fw-bold col-md-5 text-start">{input1}</span>
                      </span>
                      <span className='row pb-3'>
                        <span className='col-md-7 text-end p-0'>Overdue : </span>
                        <span className="fw-bold col-md-5 text-start">{overdueamount}</span>
                      </span>
                    </div>
                  </div>
                </div>


              </Grid.Column>


              <Grid.Column style={{ width: '45%' }} onClick={getFirstcarddata6} >
                {/* <RenderCard param1="% of overdue" param2={seriesdonut} /> */}


                <div id="chart" style={{ border: '1px solid gray', borderRadius: '10px', backgroundColor: 'white' }}>
                  <ReactApexChart options={chartDatanew.options} series={chartDatanew.series} type="donut" height={115} />
                </div>


              </Grid.Column>

              <Grid.Column style={{ width: '7%' }}>
                <div class="wrapper" style={{ paddingTop: '4em', height: '95%', width: '100%' }} >
                  <div class="icon12 facebook" onClick={handleIconClick5}>
                    <div class="tooltip">
                      Recon Summary
                    </div>
                    <span><i class="fa-solid fa-clipboard"></i></span>
                  </div>
                </div>
              </Grid.Column>
            </Grid.Row>
            
            <Grid.Row style={{ paddingTop: '0.5em',display: 'flex', gap: '0' , marginLeft:'-14px' }}>

              <Grid.Column style={{ width: '42%'}}>
                <div style={{ backgroundColor: 'white',borderRadius : '10px', border: '1px solid #111111' }}>
                  <h3 style={{ color: '#3B5999', margin: '0', textAlign:'center',fontfamily: 'Poppins'}}>Pending collections</h3>
                  <ReactApexChart
                    options={chartData1.options}
                    series={chartData1.series}
                    type="bar"
                    height={150}
                    onClick={handleBarClick1}
                  />
                </div>


              </Grid.Column>

              <Grid.Column style={{ width: '57%', padding:'0px'}}>
                <div style={{ backgroundColor: 'white',borderRadius : '10px', border: '1px solid #111111' }}>
                  <h3 style={{ color: '#3B5999', margin: '0',textAlign:'center',fontfamily: 'Poppins' }}>Ageing</h3>
                  <ReactApexChart
                    options={chartData2.options}
                    series={chartData2.series}
                    type="bar"
                    height={150}
                    onClick={handleBarClick}
                  />
                </div>


              </Grid.Column>

            </Grid.Row>
            <Grid.Row style={{ paddingTop: '0.5em', marginLeft: '-3.9px' }}>

              <Grid.Column style={{ width: '99%', backgroundColor: 'white',borderRadius : '10px', border: '1px solid #111111' }}>
                <DualBarGraph bar1Color="rgba(255, 0, 0, 0.5)" bar2Color="rgba(0, 255, 0, 0.5)"/>
              </Grid.Column>
            </Grid.Row>

          </Grid.Column>


        </Grid.Row>


      </Grid>





      {/* <Grid className='mt-2 mb-2' style={{ marginLeft: '1em' }}>
        
      </Grid> */}

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='col-md-11'>

            </div>
            <div className='col-md-1'>
              <a onClick={exportToExcel}>
                <i class='fas fa-file-excel' style={{ fontSize: '30px', color: 'green' }}></i>
              </a>
            </div></div>
          <div className="ag-theme-alpine"
            style={{ height: '400px', width: '100%' }}
          >
            <AgGridReact
              columnDefs={modelcolumnnames}
              rowData={extGridData}
              animateRows={true}

              pagination={true}
              paginationPageSize={10}
            />
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DashboardComponent;



